import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Building2, ArrowLeft } from 'lucide-react';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Helmet>
        <title>Mentions Legales | copropriete.app</title>
        <meta name="description" content="Mentions legales de copropriete.app - Editeur GMP Developpement, Chamoux-sur-Gelon" />
      </Helmet>

      <header className="bg-white border-b border-slate-200 py-4 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-bold flex items-center gap-2 text-slate-900">
            <Building2 className="w-6 h-6 text-indigo-600" />
            copropriete.app
          </Link>
          <Link to="/" className="flex items-center gap-2 text-slate-600 hover:text-slate-900">
            <ArrowLeft className="w-4 h-4" />
            Retour
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Mentions Legales</h1>
        
        <div className="bg-white rounded-xl shadow-sm p-8 space-y-8 text-slate-700 leading-relaxed">
          
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 1 - Editeur du site</h2>
            <p className="mb-4">Le site <strong>copropriete.app</strong> est edite par :</p>
            <div className="bg-slate-50 p-4 rounded-lg">
              <p><strong>SAS GMP Developpement</strong></p>
              <p>Forme juridique : Societe par Actions Simplifiee (SAS)</p>
              <p>Capital social : 2 500 euros</p>
              <p>Siege social : 51 Rue Michel Jandet, 73390 Chamoux-sur-Gelon, France</p>
              <p>SIREN : 980 507 784</p>
              <p>SIRET : 980 507 784 00018</p>
              <p>RCS : Chambery</p>
              <p>Email : <a href="mailto:gmpdeveloppement@gmail.com" className="text-indigo-600 hover:underline">gmpdeveloppement@gmail.com</a></p>
              <p>Directeur de la publication : Gary Paillet</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 2 - Hebergement</h2>
            <p>Le site copropriete.app est heberge par :</p>
            <div className="bg-slate-50 p-4 rounded-lg mt-2">
              <p><strong>Emergent</strong></p>
              <p>Plateforme d'hebergement cloud</p>
              <p>Infrastructure securisee avec chiffrement SSL/TLS</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 3 - Acces au site</h2>
            <p>Le site est accessible gratuitement en tout lieu a tout utilisateur disposant d'un acces Internet. Tous les frais supportes par l'utilisateur pour acceder au service (materiel informatique, logiciels, connexion Internet, etc.) sont a sa charge.</p>
            <p className="mt-2">L'editeur met en oeuvre tous les moyens raisonnables a sa disposition pour assurer un acces de qualite au site, mais n'est tenu a aucune obligation d'y parvenir.</p>
            <p className="mt-2">L'editeur ne peut etre tenu responsable de tout dysfonctionnement du reseau ou des serveurs ou de tout autre evenement echappant a son controle raisonnable, qui empecherait ou degraderait l'acces au site.</p>
            <p className="mt-2">L'editeur se reserve la possibilite d'interrompre, de suspendre momentanement ou de modifier sans preavis l'acces a tout ou partie du site, afin d'en assurer la maintenance ou pour toute autre raison, sans que l'interruption n'ouvre droit a aucune obligation ni indemnisation.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 4 - Propriete intellectuelle</h2>
            <p>Les marques, logos, signes ainsi que tous les contenus du site (textes, images, son, etc.) font l'objet d'une protection par le Code de la propriete intellectuelle et plus particulierement par le droit d'auteur.</p>
            <p className="mt-2">La marque <strong>copropriete.app</strong> est une marque deposee par GMP Developpement. Toute representation et/ou reproduction et/ou exploitation partielle ou totale de cette marque, de quelque nature que ce soit, est totalement prohibee.</p>
            <p className="mt-2">L'utilisateur doit solliciter l'autorisation prealable du site pour toute reproduction, publication, copie des differents contenus. Il s'engage a une utilisation des contenus du site dans un cadre strictement prive, toute utilisation a des fins commerciales et publicitaires est strictement interdite.</p>
            <p className="mt-2">Toute representation totale ou partielle de ce site par quelque procede que ce soit, sans l'autorisation expresse de l'exploitant du site Internet constituerait une contrefacon sanctionnee par l'article L 335-2 et suivants du Code de la propriete intellectuelle.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 5 - Responsabilite</h2>
            <p>Les sources des informations diffusees sur le site copropriete.app sont reputees fiables mais le site ne garantit pas qu'il soit exempt de defauts, d'erreurs ou d'omissions.</p>
            <p className="mt-2">Les informations communiquees sont presentees a titre indicatif et general sans valeur contractuelle. Malgre des mises a jour regulieres, le site copropriete.app ne peut etre tenu responsable de la modification des dispositions administratives et juridiques survenant apres la publication. De meme, le site ne peut etre tenu responsable de l'utilisation et de l'interpretation de l'information contenue dans ce site.</p>
            <p className="mt-2">L'utilisateur s'assure de garder son mot de passe secret. Toute divulgation du mot de passe, quelle que soit sa forme, est interdite. L'utilisateur assume les risques lies a l'utilisation de son identifiant et mot de passe.</p>
            <p className="mt-2">Le site copropriete.app ne saurait etre tenu pour responsable d'eventuels virus qui pourraient infecter l'ordinateur ou tout materiel informatique de l'utilisateur, suite a une utilisation, a l'acces, ou au telechargement provenant de ce site.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 6 - Liens hypertextes</h2>
            <p>Le site peut contenir des liens hypertextes vers d'autres sites presents sur le reseau Internet. Les liens vers ces autres ressources vous font quitter le site copropriete.app.</p>
            <p className="mt-2">Il est possible de creer un lien vers la page de presentation de ce site sans autorisation expresse de l'editeur. Aucune autorisation ou demande d'information prealable ne peut etre exigee par l'editeur a l'egard d'un site qui souhaite etablir un lien vers le site de l'editeur. Il convient toutefois d'afficher ce site dans une nouvelle fenetre du navigateur. Cependant, l'editeur se reserve le droit de demander la suppression d'un lien qu'il estime non conforme a l'objet du site copropriete.app.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 7 - Cookies</h2>
            <p>Le site copropriete.app peut collecter automatiquement des informations standards. Toutes les informations collectees indirectement ne seront utilisees que pour suivre le volume, le type et la configuration du trafic utilisant ce site, pour en developper la conception et l'agencement et a d'autres fins administratives et de planification et plus generalement pour ameliorer le service que nous vous offrons.</p>
            <p className="mt-2">Pour plus d'informations sur l'utilisation des cookies, veuillez consulter notre <Link to="/politique-confidentialite" className="text-indigo-600 hover:underline">Politique de Confidentialite</Link>.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 8 - Droit applicable et attribution de juridiction</h2>
            <p>Tout litige en relation avec l'utilisation du site copropriete.app est soumis au droit francais. En dehors des cas ou la loi ne le permet pas, il est fait attribution exclusive de juridiction aux tribunaux competents de Chambery.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Article 9 - Contact</h2>
            <p>Pour toute question ou demande d'information concernant le site, ou tout signalement de contenu ou d'activites illicites, l'utilisateur peut contacter l'editeur a l'adresse e-mail suivante : <a href="mailto:gmpdeveloppement@gmail.com" className="text-indigo-600 hover:underline">gmpdeveloppement@gmail.com</a>.</p>
          </section>

          <div className="pt-6 border-t border-slate-200 text-sm text-slate-500">
            <p>Derniere mise a jour : Mars 2026</p>
          </div>
        </div>
      </main>

      <footer className="bg-slate-900 text-slate-400 py-8 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm">2026 SAS GMP Developpement - copropriete.app</p>
        </div>
      </footer>
    </div>
  );
};

export default MentionsLegales;
